import { toast, ToastOptions } from 'react-toastify';

// Default toast configuration
const defaultOptions: ToastOptions = {
  position: "top-right",
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

// Custom toast utility functions
export const showToast = {
  success: (message: string, options?: ToastOptions) => {
    console.log('SUCCESS TOAST:', message);
    return toast.success(message, { ...defaultOptions, ...options });
  },
  
  error: (message: string, options?: ToastOptions) => {
    console.log('ERROR TOAST:', message);
    return toast.error(message, { ...defaultOptions, ...options });
  },
  
  info: (message: string, options?: ToastOptions) => {
    console.log('INFO TOAST:', message);
    return toast.info(message, { ...defaultOptions, ...options });
  },
  
  warning: (message: string, options?: ToastOptions) => {
    console.log('WARNING TOAST:', message);
    return toast.warning(message, { ...defaultOptions, ...options });
  }
};

// Emergency toast with maximum visibility
export const emergencyToast = (message: string) => {
  console.log('EMERGENCY TOAST:', message);
  return toast.error(message, {
    position: "top-right",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    style: {
      backgroundColor: '#ff5555',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '16px',
      border: '3px solid black',
      borderRadius: '8px',
      padding: '20px',
      textAlign: 'center',
      zIndex: 10000
    }
  });
}; 